import React from "react";
import { useTranslation } from "react-i18next";

import { Col, Row } from "react-bootstrap";
import ManageHeader from "@components/ManageHeader";
import { LucideBookmark, ScrollText } from "lucide-react";
import List from "./components/List";




const Home = (props) => {
  const { t } = useTranslation();


  return (
    <div className="rounded-4 p-4 mt-4 bg-white shadow">
      <ManageHeader
        title={t("support_tickets")}
        content={t("create_manage_open_tickets_priorities")}
        icon={<LucideBookmark size={25} strokeWidth={1.5} />}
      />


    <List/>


    </div>
  );
};


export default Home;


